(function () {

  'use strict';

  angular.module('PrintixProviderWorkstation', [])

    .constant('RequiredWorkstationModelProperties', [
      'name',
      'ipAddresses',
      'type',
      'operatingSystem'
    ])

    .constant('WorkstationEmbeddedPropertiesAdmin', '?embed=adapters,queues,tasks,networks')

    .constant('WorkstationEmbeddedProperties', '')

    .factory('WorkstationModel', function ($rootScope, Utils, $filter, PrintixWorkstationInfoConstants, $http, RequiredWorkstationModelProperties,
      $q, $injector, WorkstationEmbeddedPropertiesAdmin, WorkstationEmbeddedProperties, TenantListService, GroupModel) {

      return function (workstationDataReceived) {

        // START VARIABLES **************************************************************************************/

        const WorkstationModel = {};
        const WorkstationModelPrivate = {};
        let workstationUrlSuffix = '';
        try {
          $injector.get('APIAdmin');
          workstationUrlSuffix = WorkstationEmbeddedPropertiesAdmin;
        } catch (e) {
          workstationUrlSuffix = WorkstationEmbeddedProperties;
        }

        // END VARIABLES ****************************************************************************************/

        // START init *******************************************************************************************/

        WorkstationModel.init = function (workstationDataReceived) {
          if (Utils.objectPropertiesCheck(workstationDataReceived, RequiredWorkstationModelProperties)) {
            WorkstationModel.info = angular.copy(workstationDataReceived);
            WorkstationModel.options = {
              isSelected: false
            };
            WorkstationModel.customProperties = {};
            WorkstationModelPrivate.normalizeLinks();
          } else {
            throw new Error('WorkstationModel: workstationDataReceived is not valid');
          }
        };

        // END init *********************************************************************************************/

        // START WorkstationModel *******************************************************************************/

        WorkstationModelPrivate.normalizeLinks = function () {
          angular.forEach(WorkstationModel.info._links, function (link, index) {
            if (angular.isObject(link) && !angular.isArray(link)) {
              const linkClean = link.href.split('?')[0];
              WorkstationModel.info._links[index].href = linkClean;
            }
          });
          const selfHrefSplit = WorkstationModel.info._links.self.href.split('/');
          WorkstationModel.customProperties.id = selfHrefSplit[selfHrefSplit.length - 1];
        };

        WorkstationModel.replaceInfo = function (embeddedKey, data, doNotReplaceEmbeddedAndLinks) {
          if (!WorkstationModel.info._embedded) {
            WorkstationModel.info._embedded = {};
          }
          if (embeddedKey) {
            WorkstationModel.info._embedded[embeddedKey] = angular.copy(data);
          } else {
            const embedded = angular.copy(WorkstationModel.info._embedded);
            const links = angular.copy(WorkstationModel.info._links);
            WorkstationModel.info = angular.copy(data);
            if (!doNotReplaceEmbeddedAndLinks) {
              WorkstationModel.info._embedded = embedded;
              WorkstationModel.info._links = links;
            }
            WorkstationModelPrivate.normalizeLinks();
          }
        };

        WorkstationModel.showInfo = function () {
          $rootScope.$emit(PrintixWorkstationInfoConstants.SHOW, WorkstationModel);
        };

        WorkstationModel.getLogsFromClient = function () {
          return $http.get(WorkstationModel.info._links['px:logUpload'].href);
        };

        WorkstationModel.refreshWorkstationInfo = function () {
          const deferred = $q.defer();
          $http.get(WorkstationModel.info._links.self.href + workstationUrlSuffix)
            .then(function (response) {
              WorkstationModel.replaceInfo(null, response.data, true);
              deferred.resolve(response);
            })
            .catch(function (error) {
              deferred.reject(error);
            });
          return deferred.promise;
        };

        WorkstationModel.getDiagnostics = function () {
          const deferred = $q.defer();
          $http.get(WorkstationModel.info._links.self.href + workstationUrlSuffix)
            .then(function (response) {
              WorkstationModel.replaceInfo(null, response.data);
              if (response.data.lastConnectTime) {
                $http.get(WorkstationModel.info._links['px:diagnostics'].href)
                  .then(function (response) {
                    deferred.resolve(response);
                  })
                  .catch(function (error) {
                    deferred.reject(error);
                  });
              } else { // Fallback to proxy 1
                const difference = $filter('amDifference')(new Date(response.headers().date), WorkstationModel.info.heartbeat, 'minutes');
                if (difference < 1) {
                  $http.get(WorkstationModel.info._links['px:diagnostics'].href)
                    .then(function (response) {
                      deferred.resolve(response);
                    })
                    .catch(function (error) {
                      deferred.reject(error);
                    });
                } else {
                  deferred.reject();
                }
              }
            })
            .catch(function (error) {
              deferred.reject(error);
            });
          return deferred.promise;
        };

        WorkstationModel.deleteSelectedPrintQueues = function (printQueueList) {
          if (printQueueList && printQueueList.length > 0) {
            const deferred = $q.defer();
            const dataToSend = [];
            angular.forEach(printQueueList, function (printQueue) {
              dataToSend.push({
                workstationId: WorkstationModel.info._links.self.href,
                workstationPrintQueueId: printQueue._links.self.href,
                printerId: printQueue._links['px:printer'].href,
                queueId: printQueue._links['px:queue'].href
              });
            });
            $http.post(TenantListService.currentTenant.info._links['px:commandDeleteWsQueues'].href, dataToSend)
              .then(function () {
                deferred.resolve();
              })
              .catch(function (error) {
                deferred.reject(error);
              });
            return deferred.promise;
          } else {
            throw new Error('WorkstationModel.deletePrintQueue: printQueueList is missing or empty');
          }
        };

        WorkstationModel.addSelectedPrintQueues = function (printQueueList) {
          if (printQueueList && printQueueList.length > 0) {
            const deferred = $q.defer();
            const dataToSend = [];
            angular.forEach(printQueueList, function (printQueue) {
              dataToSend.push({
                workstationId: WorkstationModel.info._links.self.href,
                printerId: printQueue.info._links['px:printer'].href,
                queueId: printQueue.info._links.self.href
              });
            });
            $http.post(TenantListService.currentTenant.info._links['px:commandAddWsQueues'].href, dataToSend)
              .then(function () {
                deferred.resolve();
              })
              .catch(function (error) {
                deferred.reject(error);
              });
            return deferred.promise;
          } else {
            throw new Error('WorkstationModel.deletePrintQueue: printQueueList is missing or empty');
          }
        };

        WorkstationModel.forceWorkstationsToGetLatestQueueUpdates = function (printQueue, printer) {
          const deferred = $q.defer();
          const dataToSend = [];
          const dataPackage = {
            printerId: printer.info._links.self.href,
            queueId: printQueue.info._links.self.href
          };
          dataToSend.push(dataPackage);
          $http.post(TenantListService.currentTenant.info._links['px:commandUpdateWsQueues'].href, dataToSend)
            .then(function () {
              deferred.resolve();
            })
            .catch(function (error) {
              deferred.reject(error);
            });
          return deferred.promise;
        };

        WorkstationModel.forceWorkstationToGetLatestQueueUpdates = function (printQueueList) {
          if (printQueueList && printQueueList.length > 0) {
            const deferred = $q.defer();
            const dataToSend = [];
            angular.forEach(printQueueList, function (printQueue) {
              dataToSend.push({
                workstationId: WorkstationModel.info._links.self.href,
                printerId: printQueue._links['px:printer'].href,
                queueId: printQueue._links['px:queue'].href,
                queueName: printQueue.name
              });
            });
            $http.post(TenantListService.currentTenant.info._links['px:commandUpdateWsQueues'].href, dataToSend)
              .then(function () {
                deferred.resolve();
              })
              .catch(function () {
                deferred.reject();
              });
            return deferred.promise;
          } else {
            throw new Error('WorkstationModel.deletePrintQueue: printQueueList is missing or empty');
          }
        };

        WorkstationModel.setDefaultPrintQueue = function (printQueueUrl) {
          const deferred = $q.defer();
          printQueueUrl = JSON.stringify(printQueueUrl);
          const url = WorkstationModel.info._links['px:updateDefaultQueue'].href;
          $http.post(url, printQueueUrl)
            .then(function (response) {
              deferred.resolve(response);
            })
            .catch(function (error) {
              deferred.reject(error);
            });
          return deferred.promise;
        };

        WorkstationModel.getGroups = function (groupPaginationObject) {
          const deferred = $q.defer();
          const url = WorkstationModel.info._links['px:groups'].href + '?' + groupPaginationObject.getPagedUrlParameters();
          $http.get(url)
            .then(function (response) {
              const groupListObject = {
                page: response.data.page,
                _links: response.data._links,
                list: []
              };
              if (response.data && response.data._embedded && response.data._embedded['px:groupResources']) {
                angular.forEach(response.data._embedded['px:groupResources'], function (groupData) {
                  groupListObject.list.add(new GroupModel(groupData));
                });
              }
              deferred.resolve(groupListObject);
            })
            .catch(function (error) {
              deferred.reject(error);
            });
          return deferred.promise;
        };

        WorkstationModel.addNetworks = function (networks) {
          const deferred = $q.defer();
          const postObject = {
            networks
          };
          const url = WorkstationModel.info._links['px:networks'].href;
          $http.post(url, postObject)
            .then(function (response) {
              deferred.resolve(response);
            })
            .catch(function (error) {
              deferred.reject(error);
            });
          return deferred.promise;
        };

        WorkstationModel.pingPrinter = function (ipAddress) {
          const deferred = $q.defer();
          const postObject = ipAddress;
          const url = WorkstationModel.info._links['px:pingPrinter'].href;
          $http.post(url, postObject)
            .then(function (response) {
              deferred.resolve(response);
            })
            .catch(function (error) {
              deferred.reject(error);
            });
          return deferred.promise;
        };

        WorkstationModel.testNetwork = function () {
          const deferred = $q.defer();
          const postObject = {};
          const url = WorkstationModel.info._links['px:testNetwork'].href;
          $http.post(url, postObject)
            .then(function (response) {
              deferred.resolve(response);
            })
            .catch(function (error) {
              deferred.reject(error);
            });
          return deferred.promise;
        };

        // END WorkstationModel *********************************************************************************/

        // START CREATE *****************************************************************************************/

        WorkstationModel.init(workstationDataReceived);
        delete WorkstationModel.init;

        // END CREATE *******************************************************************************************/

        WorkstationModel.saveChanges = function (workstationChanged) {
          if (workstationChanged) {
            const patchObjectArray = Utils.getObjectsDifferencesForPatching(WorkstationModel.info, workstationChanged.info);
            if (patchObjectArray && patchObjectArray.length > 0) {
              const defered = $q.defer();
              $http.patch(WorkstationModel.info._links.self.href + workstationUrlSuffix, patchObjectArray)
                .then(function (response) {
                  WorkstationModel.replaceInfo(null, response.data);
                  defered.resolve(response);
                })
                .catch(function (error) {
                  defered.reject(error);
                });
              return defered.promise;
            } else {
              return $q.resolve();
            }
          } else {
            throw new Error('workstationChanged is missing');
          }
        };

        return WorkstationModel;
      };
    })

    .factory('WorkstationListPOSTPaging', function (DEFAULT_ITEMS_PER_PAGE) {
      return function () {
        return {
          pagingCriteria: {
            page: 0,
            pageSize: DEFAULT_ITEMS_PER_PAGE,
            sort: 'NAME',
            direction: 'ASC',
            match: null,
            user: null,
            embed: ['adapters', 'queues', 'tasks', 'networks'],
            networkFilters: null,
            systems: null,
            types: null,
            gwId: undefined,
            gwMac: undefined,
            queue: null,
            queueFilterMode: null,
            printGateway: null,
            scanGateway: null,
            active: null,
            networkFilterEnabled: null,
            groups: null,
            wppEnabled: undefined
          }
        };
      };
    })

    .factory('WorkstationListPaging', function (DEFAULT_ITEMS_PER_PAGE) {
      return function () {
        const WorkstationListPaging = {};
        WorkstationListPaging.pagingCriteria = {
          page: 0,
          pageSize: DEFAULT_ITEMS_PER_PAGE,
          sort: 'NAME',
          direction: 'ASC',
          match: null,
          user: null,
          embed: null,
          networks: null,
          systems: null,
          types: null,
          gateway: null,
          queue: null,
          queueFilterMode: null,
          printGateway: null,
          scanGateway: null,
          active: null,
          networkFilterEnabled: null,
          groups: null,
          wppEnabled: undefined
        };

        WorkstationListPaging.getPagedUrlParameters = function () {
          let urlParameters =
              'page=' + WorkstationListPaging.pagingCriteria.page +
              '&pageSize=' + WorkstationListPaging.pagingCriteria.pageSize +
              '&sort=' + WorkstationListPaging.pagingCriteria.sort +
              '&direction=' + WorkstationListPaging.pagingCriteria.direction;
          if (WorkstationListPaging.pagingCriteria.systems) {
            urlParameters += '&systems=' + WorkstationListPaging.pagingCriteria.systems;
          }
          if (WorkstationListPaging.pagingCriteria.types) {
            urlParameters += '&types=' + WorkstationListPaging.pagingCriteria.types;
          }
          if (WorkstationListPaging.pagingCriteria.networks) {
            urlParameters += '&networkFilters=' + WorkstationListPaging.pagingCriteria.networks;
          }
          if (WorkstationListPaging.pagingCriteria.match) {
            urlParameters += '&match=' + WorkstationListPaging.pagingCriteria.match;
          }
          if (WorkstationListPaging.pagingCriteria.gateway) {
            urlParameters += '&gwIp=' + WorkstationListPaging.pagingCriteria.gateway.gwIp;
            urlParameters += '&gwMac=' + WorkstationListPaging.pagingCriteria.gateway.gwMac;
          }
          if (WorkstationListPaging.pagingCriteria.queue) {
            urlParameters += '&queue=' + WorkstationListPaging.pagingCriteria.queue;
          }
          if (WorkstationListPaging.pagingCriteria.queueFilterMode) {
            urlParameters += '&queueFilterMode=' + WorkstationListPaging.pagingCriteria.queueFilterMode;
          }
          if (WorkstationListPaging.pagingCriteria.user) {
            urlParameters += '&user=' + WorkstationListPaging.pagingCriteria.user;
          }
          if (WorkstationListPaging.pagingCriteria.printGateway !== null) {
            urlParameters += '&printGateway=' + WorkstationListPaging.pagingCriteria.printGateway;
          }
          if (WorkstationListPaging.pagingCriteria.scanGateway !== null) {
            urlParameters += '&scanGateway=' + WorkstationListPaging.pagingCriteria.scanGateway;
          }
          if (WorkstationListPaging.pagingCriteria.active !== null) {
            urlParameters += '&active=' + WorkstationListPaging.pagingCriteria.active;
          }
          if (WorkstationListPaging.pagingCriteria.networkFilterEnabled !== null) {
            urlParameters += '&networkFilterEnabled=' + WorkstationListPaging.pagingCriteria.networkFilterEnabled;
          }
          if (WorkstationListPaging.pagingCriteria.groups !== null) {
            urlParameters += '&groups=' + WorkstationListPaging.pagingCriteria.groups;
          }
          if (WorkstationListPaging.pagingCriteria.wppEnabled !== undefined && WorkstationListPaging.pagingCriteria.wppEnabled !== null) {
            urlParameters += '&wppEnabled=' + WorkstationListPaging.pagingCriteria.wppEnabled;
          }
          return urlParameters;
        };

        return WorkstationListPaging;
      };
    }
    )

    .service('WorkstationListService', function ($rootScope, WorkstationModel, TenantListService, $http,
      $q, WorkstationEmbeddedPropertiesAdmin, WorkstationEmbeddedProperties, $injector, $log) {

      const workstationListServiceAsObject = this;
      let workstationUrlSuffix = '';
      try {
        $injector.get('APIAdmin');
        workstationUrlSuffix = WorkstationEmbeddedPropertiesAdmin;
      } catch (e) {
        workstationUrlSuffix = WorkstationEmbeddedProperties;
      }

      this.getWorkstationById = function (workstationId) {
        if (workstationId) {
          const deferred = $q.defer();
          const watch = $rootScope.$watch(function () {
            return TenantListService.currentTenant;
          }, function () {
            if (TenantListService.currentTenant &&
                TenantListService.currentTenant.info._links['px:workstations'].href) {
              $http.get(TenantListService.currentTenant.info._links['px:workstations'].href + '/' + workstationId + workstationUrlSuffix)
                .then(function (response) {
                  if (response && response.data) {
                    deferred.resolve(new WorkstationModel(response.data));
                  } else {
                    watch();
                    deferred.reject(response);
                  }
                })
                .catch(function (error) {
                  watch();
                  deferred.reject(error);
                });
            }
          });
          return deferred.promise;
        } else {
          throw new Error('WorkstationModel.getWorkstationById: workstationId is missing');
        }
      };

      this.getWorkstationByUrl = function (url) {
        const deferred = $q.defer();
        const watch = $rootScope.$watch(function () {
          return TenantListService.currentTenant;
        }, function () {
          if (TenantListService.currentTenant &&
              TenantListService.currentTenant.info._links['px:workstations'].href) {
            $http.get(url + workstationUrlSuffix)
              .then(function (response) {
                if (response && response.data) {
                  deferred.resolve(new WorkstationModel(response.data));
                } else {
                  watch();
                  deferred.reject(response);
                }
              })
              .catch(function (error) {
                watch();
                deferred.reject(error);
              });
          }
        });
        return deferred.promise;
      };

      this.deleteWorkstation = function (workstation) {
        if (workstation) {
          const deferred = $q.defer();
          $http.delete(workstation.info._links.self.href)
            .then(function () {
              deferred.resolve();
            })
            .catch(function (error) {
              deferred.reject(error);
            });
          return deferred.promise;
        } else {
          throw new Error('WorkstationListService.deleteWorkstation: workstation is missing');
        }
      };

      this.deleteSelectedWorkstations = function (workstationList, callback) {
        if (workstationList && workstationList.length > 0) {
          angular.forEach(workstationList, function (workstation) {
            workstationListServiceAsObject.deleteWorkstation(workstation);
          });
          if (callback) {
            callback();
          }
        } else {
          throw new Error('WorkstationListService.deleteSelectedWorkstations: workstationList is missing or it`s length is less than 1');
        }
      };

      this.getWorkstationListPaged = function (workstationListPaging) {
        if (Object.hasOwn(workstationListPaging.pagingCriteria, 'networkFilters')) {
          $log.error('WorkstationListService.getWorkstationListPaged(): Called with WorkstationListPOSTPaging parameter \'networkFilters\'!');
        }

        if (workstationListPaging && TenantListService.currentTenant && TenantListService.currentTenant.info) {
          const deferred = $q.defer();
          $http.get(TenantListService.currentTenant.info._links['px:workstations'].href + '?' + workstationListPaging.getPagedUrlParameters() +
              workstationUrlSuffix.replace('?', '&'))
            .then(function (response) {
              const workStationsListObject = {
                page: response.data.page,
                _links: response.data._links,
                list: []
              };
              if (response.data && response.data._embedded && response.data._embedded['px:workstationResources']) {
                angular.forEach(response.data._embedded['px:workstationResources'], function (workstationsData) {
                  workStationsListObject.list.add(new WorkstationModel(workstationsData));
                });
              }
              deferred.resolve(workStationsListObject);
            })
            .catch(function (error) {
              deferred.reject(error);
            });
          return deferred.promise;
        } else {
          throw new Error('WorkstationListService.getWorkstationListPaged: workstationListPaging or TenantListService.currentTenant or TenantListService.currentTenant.info are missing');
        }
      };

      this.postGetWorkstationListPaged = function (WorkstationListPOSTPaging) {
        if (Object.hasOwn(WorkstationListPOSTPaging.pagingCriteria, 'networks')) {
          $log.error('WorkstationListService.postGetWorkstationListPaged(): Called with WorkstationListPaging parameter \'networks\'!');
        }

        // var networks = WorkstationListPOSTPaging.pagingCriteria.networks;
        // if (networks) {
        //   WorkstationListPOSTPaging.pagingCriteria.networkFilters = networks;
        // }
        // delete WorkstationListPOSTPaging.pagingCriteria.networks;

        if (WorkstationListPOSTPaging.pagingCriteria.networkFilters && !angular.isArray(WorkstationListPOSTPaging.pagingCriteria.networkFilters)) {
          WorkstationListPOSTPaging.pagingCriteria.networkFilters = WorkstationListPOSTPaging.pagingCriteria.networkFilters.split(',');
        }

        const deferred = $q.defer();
        const queryParams = '?find';

        $http.post(TenantListService.currentTenant.info._links['px:workstations'].href + queryParams, WorkstationListPOSTPaging.pagingCriteria)
          .then(function (response) {
            const workstationListObject = {
              page: response.data.page,
              _links: response.data._links,
              networks: [],
              list: []
            };
            if (response.data && response.data._embedded && response.data._embedded['px:workstationResources']) {
              angular.forEach(response.data._embedded['px:workstationResources'], function (workstationData) {
                workstationListObject.list.add(new WorkstationModel(workstationData));
              });
            }
            deferred.resolve(workstationListObject);
          })
          .catch(function (error) {
            deferred.reject(error);
          });
        return deferred.promise;
      };

    });

})();
